var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0C20.1795 0 26 5.82053 26 13C26 20.1795 20.1795 26 13 26C5.82053 26 0 20.1795 0 13C0 5.82053 5.82053 0 13 0ZM17.9022 16.6767L14.2255 13L17.9022 9.32331C18.709 8.51644 17.4835 7.29092 16.6766 8.09779L12.9999 11.7745L9.32325 8.09779C8.51639 7.29092 7.29086 8.51644 8.09773 9.32331L11.7744 13L8.09773 16.6767C7.29086 17.4836 8.51639 18.7091 9.32325 17.9022L12.9999 14.2255L16.6766 17.9022C17.4835 18.7091 18.709 17.4836 17.9022 16.6767ZM20.967 5.03302C16.5672 0.633245 9.4328 0.633245 5.03302 5.03302C0.633245 9.4328 0.633245 16.5672 5.03302 20.9658C9.4328 25.3656 16.5672 25.3656 20.967 20.9658C25.3668 16.5669 25.3668 9.4328 20.967 5.03302Z",
    fill: "#909090",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseButton);
export default __webpack_public_path__ + "static/media/iconCloseButton.6c6ca683fa6166982819c7d1dbdd5221.svg";
export { ForwardRef as ReactComponent };